import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useExpenses } from '../hooks/useExpenses';
import type { ExpenseFilters } from '../types';

import ExpenseList from '../components/expenses/ExpenseList';
import ExpenseFiltersBar from '../components/expenses/ExpenseFilters';
import ExpenseForm from '../components/expenses/ExpenseForm';
import Modal from '../components/ui/Modal';
import Button from '../components/ui/Button';

const DEFAULT_FILTERS: ExpenseFilters = {
  search: '',
  category: 'all',
  dateFrom: '',
  dateTo: '',
  recurring: 'all',
};

export default function Expenses() {
  const [filters, setFilters] = useState<ExpenseFilters>(DEFAULT_FILTERS);
  const [addOpen, setAddOpen] = useState(false);

  const {
    expenses,
    loading,
    error,
    totalCount,
    createExpense,
    updateExpense,
    deleteExpense,
  } = useExpenses(filters);

  return (
    <>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Expenses</h1>
          <p className="text-slate-400 text-sm mt-0.5">
            {totalCount} expense{totalCount !== 1 ? 's' : ''}
          </p>
        </div>
        <Button
          onClick={() => setAddOpen(true)}
          leftIcon={<Plus size={16} />}
        >
          New Expense
        </Button>
      </div>



      {/* Filters */}
      <div className="mb-4">
        <ExpenseFiltersBar filters={filters} onChange={setFilters} />
      </div>

      {/* List */}
      <ExpenseList
        expenses={expenses}
        loading={loading}
        error={error}
        onUpdate={updateExpense}
        onDelete={deleteExpense}
      />

      {/* Add modal */}
      <Modal open={addOpen} onClose={() => setAddOpen(false)} title="New Expense">
        <ExpenseForm
          onCreate={createExpense}
          onSuccess={() => setAddOpen(false)}
          onCancel={() => setAddOpen(false)}
        />
      </Modal>
    </>
  );
}
